export const concertsData = [
  { id: 1, name: 'Владимир', concertdate: '2025-10-10', time_start: '20:00:00', image: require('./pics/vladimir.png'), address: 'ул. Дворянская, 27а, корпус 2, ВЗПО Техника' },
  { id: 2, name: 'Тверь', concertdate: '2025-10-11', time_start: '19:00:00', image: require('./pics/tver1.png'), address: 'ул. Желябова, 1' },
  { id: 3, name: 'Тула', concertdate: '2025-10-12', time_start: '20:00:00', image: require('./pics/tula.png'), address: 'ул. Каминского, 24в, ТЦ "Тройка", 3 этаж' },
  { id: 4, name: 'Ярославль', concertdate: '2025-10-13', time_start: '21:00:00', image: require('./pics/yaroslavl.png'), address: 'Волжская наб., 4' },
  { id: 5, name: 'Тюмень', concertdate: '2025-10-17', time_start: '20:00:00', image: require('./pics/tumen.png'), address: 'ул. Челюскинцев, 40' },
  { id: 6, name: 'Челябинск', concertdate: '2025-10-18', time_start: '19:00:00', image: require('./pics/chelyabinsk.png'), address: 'просп. Ленина, 66а, стр. 1' },
  { id: 7, name: 'Екатеринбург', concertdate: '2025-10-19', time_start: '21:00:00', image: require('./pics/ekaterinburg.png'), address: 'ул. Карьерная, 16' },
  { id: 8, name: 'Пермь', concertdate: '2025-10-20', time_start: '21:00:00', image: require('./pics/perm.png'), address: 'ул. Краснофлотская, 15а' },
  { id: 9, name: 'Ижевск', concertdate: '2025-10-23', time_start: '20:00:00', image: require('./pics/ishevsk.png'), address: 'ул. Автозаводская, 1' },
  { id: 10, name: 'Уфа', concertdate: '2025-10-24', time_start: '20:00:00', image: require('./pics/ufa.png'), address: 'ул. Цюрупы, 17' },
  { id: 11, name: 'Самара', concertdate: '2025-10-25', time_start: '21:00:00', image: require('./pics/samara.png'), address: 'ул. Ленинградская, 29' },
  { id: 12, name: 'Казань', concertdate: '2025-10-26', time_start: '22:00:00', image: require('./pics/kazan.png'), address: 'ул. Профсоюзная, 22' },
  { id: 13, name: 'Нижний Новгород', concertdate: '2025-10-27', time_start: '19:00:00', image: require('./pics/niznovgorod.png'), address: 'ул. Пискунова, 11' },
  { id: 19, name: 'Новосибирск', concertdate: '2025-10-31', time_start: '21:00:00', image: require('./pics/novosibirsk.png'), address: 'ул. Геодезическая, 2/1, цокольный этаж' },
  { id: 20, name: 'Красноярск', concertdate: '2025-11-01', time_start: '20:00:00', image: require('./pics/krasnoyarsk.png'), address: 'просп. им. газеты Красноярский Рабочий, 160/1' },
  { id: 21, name: 'Иркутск', concertdate: '2025-11-03', time_start: '20:00:00', image: require('./pics/irkutsk.png'), address: 'ул. Седова, 65а/1' },
  { id: 22, name: 'Москва', concertdate: '2026-03-23', time_start: '20:00:00', image: require('./pics/moscow.png'), address: 'Партийный пер., 1, корп. 6' },
  { id: 23, name: 'Санкт-Петербург', concertdate: '2026-03-29', time_start: '20:00:00', image: require('./pics/saint-peterburg.png'), address: 'наб. реки Мойки, 20' },
];

const soldTicketsData = [
  { city_id: 1, row: 1, number: 1 }, { city_id: 1, row: 1, number: 2 }, { city_id: 1, row: 1, number: 3 },
  { city_id: 1, row: 4, number: 7 }, { city_id: 1, row: 5, number: 7 }, { city_id: 1, row: 5, number: 8 },
  { city_id: 1, row: 5, number: 11 }, { city_id: 1, row: 6, number: 7 }, { city_id: 1, row: 6, number: 8 },
  { city_id: 1, row: 7, number: 17 }, { city_id: 1, row: 8, number: 1 }, { city_id: 1, row: 8, number: 20 },
  { city_id: 1, row: 9, number: 1 }, { city_id: 1, row: 9, number: 13 }, { city_id: 1, row: 9, number: 20 },
  { city_id: 1, row: 10, number: 13 }, { city_id: 1, row: 11, number: 20 }, { city_id: 1, row: 12, number: 15 },
  { city_id: 1, row: 12, number: 20 }, { city_id: 1, row: 14, number: 6 }, { city_id: 1, row: 16, number: 8 },
  { city_id: 1, row: 17, number: 12 }, { city_id: 1, row: 18, number: 13 }, { city_id: 1, row: 19, number: 6 },
  { city_id: 1, row: 21, number: 1 }, { city_id: 1, row: 21, number: 15 }, { city_id: 1, row: 22, number: 1 },
  { city_id: 1, row: 22, number: 9 }, { city_id: 1, row: 24, number: 1 }, { city_id: 1, row: 24, number: 2 },

  { city_id: 16, row: 1, number: 1 }, { city_id: 18, row: 1, number: 6 }, { city_id: 6, row: 1, number: 7 },
  { city_id: 18, row: 1, number: 7 }, { city_id: 18, row: 1, number: 8 }, { city_id: 13, row: 1, number: 12 },
  { city_id: 16, row: 1, number: 12 }, { city_id: 15, row: 2, number: 5 }, { city_id: 15, row: 2, number: 6 },
  { city_id: 15, row: 2, number: 11 }, { city_id: 15, row: 2, number: 12 }, { city_id: 9, row: 4, number: 5 },
  { city_id: 15, row: 4, number: 5 }, { city_id: 15, row: 4, number: 10 }, { city_id: 15, row: 4, number: 11 },
  { city_id: 9, row: 4, number: 14 }, { city_id: 15, row: 4, number: 16 }, { city_id: 11, row: 5, number: 5 },
  { city_id: 15, row: 5, number: 5 }, { city_id: 13, row: 5, number: 6 }, { city_id: 5, row: 5, number: 10 },
  { city_id: 13, row: 5, number: 10 }, { city_id: 7, row: 5, number: 16 }, { city_id: 15, row: 5, number: 16 },
  { city_id: 15, row: 6, number: 6 }, { city_id: 5, row: 6, number: 10 }, { city_id: 15, row: 6, number: 15 },
  { city_id: 7, row: 6, number: 17 }, { city_id: 13, row: 7, number: 5 }, { city_id: 15, row: 7, number: 7 },
  { city_id: 13, row: 7, number: 12 }, { city_id: 5, row: 7, number: 13 }, { city_id: 15, row: 7, number: 14 },
  { city_id: 7, row: 7, number: 18 }, { city_id: 13, row: 3, number: 5 }, { city_id: 15, row: 3, number: 5 },
  { city_id: 15, row: 3, number: 8 }, { city_id: 15, row: 3, number: 11 }, { city_id: 6, row: 3, number: 12 },
  { city_id: 15, row: 3, number: 14 }, { city_id: 15, row: 8, number: 8 }, { city_id: 13, row: 8, number: 11 },
  { city_id: 5, row: 8, number: 12 }, { city_id: 13, row: 8, number: 12 }, { city_id: 15, row: 8, number: 13 },
  { city_id: 13, row: 8, number: 14 }, { city_id: 7, row: 8, number: 19 }, { city_id: 13, row: 9, number: 8 },
  { city_id: 15, row: 9, number: 9 }, { city_id: 9, row: 9, number: 12 }, { city_id: 15, row: 9, number: 12 },
  { city_id: 12, row: 9, number: 16 }, { city_id: 7, row: 9, number: 20 }, { city_id: 15, row: 10, number: 8 },
  { city_id: 15, row: 10, number: 9 }, { city_id: 17, row: 10, number: 10 }, { city_id: 11, row: 10, number: 12 },
  { city_id: 5, row: 12, number: 19 }, { city_id: 5, row: 12, number: 20 }, { city_id: 9, row: 12, number: 20 },
  { city_id: 12, row: 12, number: 20 }, { city_id: 8, row: 13, number: 1 }, { city_id: 16, row: 13, number: 1 },
  { city_id: 8, row: 13, number: 10 }, { city_id: 16, row: 13, number: 10 }, { city_id: 17, row: 11, number: 12 },
  { city_id: 5, row: 11, number: 19 }, { city_id: 5, row: 11, number: 20 }, { city_id: 16, row: 15, number: 1 },
  { city_id: 13, row: 15, number: 20 }, { city_id: 16, row: 15, number: 20 }, { city_id: 13, row: 16, number: 7 },
  { city_id: 5, row: 16, number: 20 }, { city_id: 16, row: 17, number: 1 }, { city_id: 9, row: 17, number: 12 },
  { city_id: 5, row: 17, number: 20 }, { city_id: 12, row: 17, number: 20 }, { city_id: 13, row: 17, number: 20 },
  { city_id: 16, row: 17, number: 20 }, { city_id: 16, row: 21, number: 1 }, { city_id: 13, row: 21, number: 15 },
  { city_id: 16, row: 21, number: 20 }, { city_id: 16, row: 22, number: 1 }, { city_id: 16, row: 22, number: 20 },
  { city_id: 8, row: 24, number: 1 }, { city_id: 16, row: 24, number: 1 }, { city_id: 5, row: 24, number: 5 },
  { city_id: 5, row: 24, number: 6 }, { city_id: 8, row: 24, number: 6 }, { city_id: 16, row: 24, number: 6 }
];

export const getTicketsForCity = (cityId, cityName) => {
    const tickets = [];
    const rowsConfig = [12, 16, 18, 20, 20, 20, 20, 20, 20, 16, 20, 20, 10, 12, 20, 20, 20, 14, 12, 20, 20, 20, 16, 6];

    rowsConfig.forEach((seatsCount, index) => {
        const rowNum = index + 1;
        for (let n = 1; n <= seatsCount; n++) {
            let cost = 2900;
            let typeid = 2;

            if (rowNum >= 5 && rowNum <= 10) {
                if (n >= 5 && n <= 16 && rowNum !== 6 && rowNum !== 7) {
                    cost = 2100;
                    typeid = 1;
                }
            } else if (rowNum >= 13 && rowNum <= 19) {
                cost = 4400;
                typeid = 4;
            } else if (rowNum === 20) {
                if (n >= 5 && n <= 16) {
                    cost = 4400;
                    typeid = 4;
                } else {
                    cost = 3500;
                    typeid = 3;
                }
            } else if (rowNum >= 21) {
                cost = 3500;
                typeid = 3;
            }

            const isSold = soldTicketsData.some(
                s => s.city_id === cityId && s.row === rowNum && s.number === n
            );

            tickets.push({
                id: `${cityId}-${rowNum}-${n}`,
                name: cityName,
                city_id: cityId,
                number: n,
                row: rowNum,
                cost: cost,
                typeid: typeid,
                status: isSold ? 'sold' : null,
                selected: isSold
            });
        }
    });
    return tickets;
};